import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=d3b0d970&scoped=true"
var script = {}
import style0 from "./Group.vue?vue&type=style&index=0&id=d3b0d970&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b0d970",
  null
  
)

export default component.exports